import React from 'react';
import Icon from '../../../components/AppIcon';

const ArticleFilters = ({
  searchQuery,
  onSearchChange,
  selectedCategory,
  onCategoryChange,
  sortBy,
  onSortChange,
  totalResults,
}) => {
  const categories = [
    { value: 'all', label: 'Tous', icon: 'Grid' },
    { value: 'blog', label: 'Blog', icon: 'FileText' },
    { value: 'announcement', label: 'Annonces', icon: 'Megaphone' },
  ];

  const sortOptions = [
    { value: 'date', label: 'Plus récent', icon: 'Calendar' },
    { value: 'title', label: 'Titre (A-Z)', icon: 'SortAsc' },
  ];

  return (
    <div className="flex flex-col md:flex-row gap-4 items-start md:items-center justify-between">
      {/* Left side: Search bar + result count */}
      <div className="flex items-center gap-3">
        <div className="relative w-full md:w-80">
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 dark:text-slate-400 pointer-events-none">
            <Icon name="Search" size={18} />
          </div>
          <input
            type="text"
            placeholder="Rechercher des articles..."
            value={searchQuery}
            onChange={(e) => onSearchChange?.(e.target.value)}
            className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 dark:border-white/10 bg-white dark:bg-slate-900/60 text-slate-900 dark:text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500/30 text-sm transition-all"
          />
        </div>
        <span className="text-sm text-slate-500 whitespace-nowrap">
          {totalResults} article{totalResults !== 1 ? 's' : ''}
        </span>
      </div>

      {/* Right side: Category pills + sort buttons */}
      <div className="flex flex-wrap items-center gap-3">
        {/* Category pills */}
        <div className="inline-flex items-center gap-2">
          {categories.map((category) => (
            <button
              key={category.value}
              type="button"
              onClick={() => onCategoryChange?.(category.value)}
              className={`flex items-center gap-1.5 px-3.5 py-2 rounded-xl text-sm font-medium transition-all ${
                selectedCategory === category.value
                  ? 'bg-blue-600 text-white shadow-lg shadow-blue-600/25'
                  : 'bg-slate-100 dark:bg-slate-800/60 text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-slate-200 dark:hover:bg-slate-800 border border-slate-200 dark:border-white/5'
              }`}
            >
              <Icon name={category.icon} size={15} />
              {category.label}
            </button>
          ))}
        </div>

        {/* Sort buttons */}
        <div className="flex items-center gap-1">
          {sortOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => onSortChange?.(option.value)}
              className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm transition-all ${
                sortBy === option.value
                  ? 'bg-slate-100 dark:bg-slate-800 text-slate-900 dark:text-white border border-slate-200 dark:border-white/10'
                  : 'text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
              }`}
            >
              <Icon name={option.icon} size={15} />
              {option.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ArticleFilters;
